/**
 * Creates Youtube player and handles inline and overlay playback
 *
 * @file Creates Youtube player and handles inline playback
 * @author michael.schmid@notch-interactive.com
 * @param {object}  options - overwrites default settings (optional)
 *
 * */

let instance = {},
    settings = {},
    defaults = {
        videoTrigger: '[data-video-trigger]',
        youtubeScriptUrl: 'https://www.youtube.com/iframe_api',
        visibleClass: 'is-visible',
        fixedClass: 'is-fixed',
        hiddenClass: 'is-hidden',
        scriptId: 'youtube-iframe-api',
        transitionTime: 500,
        boundAttr: 'data-video-bound'
    },
    videoTriggers,
    videoInfo = {},
    players = {},
    youtubeIsReady = false,

    retrieveVideoInformation = (target) => {
        videoInfo.id = target.dataset.videoTargetId;
        videoInfo.videoId = target.dataset.videoId;
        return videoInfo;
    },

    loadPlayerScript = () => {
        let scriptId = document.getElementById(settings.scriptId);

        // Check if script was already added
        if (scriptId === null) {
            let script = document.createElement('script');
            script.src = settings.youtubeScriptUrl;
            script.id = settings.scriptId;
            document.head.appendChild(script);
        }
    },

    initializeYoutubePlayer = () => {
        let player;

        player = new YT.Player(videoInfo.id, {
            height: '100%',
            width: '100%',
            videoId: videoInfo.videoId,
            playerVars: {
                'loop': 0,
                'playlist': 0,
                'rel': 0,
                'showinfo': 0,
                'modestbranding': 0,
                'color': 'white'
            },
            events: {
                'onReady': () => {
                    // player.playVideo();
                }
            }
        });

        players[videoInfo.id] = player;
    },

    initializeAllPlayers = () => {
        videoTriggers.forEach((trigger) => {
            retrieveVideoInformation(trigger);
            loadPlayerScript();
            initializeYoutubePlayer();
        });
    },

    bindEvents = () => {

        videoTriggers.forEach((videoTrigger) => {

            // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
            videoTrigger.setAttribute(settings.boundAttr, '');

            videoTrigger.addEventListener('click', (e) => {
                let target = e.currentTarget,
                    targetId = target.dataset.videoTargetId,
                    videoInfo = retrieveVideoInformation(target);
                loadPlayerScript();
                target.classList.remove(settings.visibleClass);
                document.getElementById(targetId).classList.remove(settings.hiddenClass);

                // If player was already initialized, just resume video
                if (players[videoInfo.id] !== undefined) {
                    players[videoInfo.id].playVideo();

                    // Otherwise, initialize it
                } else if (youtubeIsReady) {
                    initializeYoutubePlayer();
                }
            });
        });

    };

let initializeYoutubeVideo = () => {
    youtubeIsReady = true;

    if (document.readyState === 'complete') {
        initializeAllPlayers();
    } else {
        document.addEventListener('readystatechange', () => {
            if (document.readyState === 'complete') {
                initializeAllPlayers();
            }
        });
    }
};

// Global variable that gets called after Youtube iFrame API script finished loading
window.onYouTubeIframeAPIReady = () => {
    initializeYoutubeVideo();
};

instance.init = (options) => {
    settings = Object.assign({}, defaults, options);
    videoTriggers = [...document.querySelectorAll(settings.videoTrigger + ':not([' + settings.boundAttr + '])')];

    if (videoTriggers.length) {
        bindEvents();
        loadPlayerScript();
    }

};

module.exports = instance;
